export default __webpack_public_path__ + "static/media/formsign_img.10f91d31.png";